<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4>
          <ion-icon name="calendar-outline"></ion-icon> {{ lblName }} Blog
        </h4>
      </div>
    </div>
    <div class="blog-add-content mt-3">
      <form action="" [formGroup]="blogForm">
        <div class="row">
          <div class="col-lg-9 col-md-9 col-sm-12 col-12">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Blog Name <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Blog Name"
                      formControlName="blogName"
                      [ngClass]="{
                        'is-invalid':
                          add.blogName.touched && add.blogName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.blogName.touched && add.blogName.errors"
                    >
                      <span *ngIf="add.blogName.errors.required"
                        >Blog Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Blog Short Description
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Blog Short Description"
                      formControlName="blogShortDescription"
                      [ngClass]="{
                        'is-invalid':
                          add.blogShortDescription.touched &&
                          add.blogShortDescription.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.blogShortDescription.touched &&
                        add.blogShortDescription.errors
                      "
                    >
                      <span *ngIf="add.blogShortDescription.errors.required"
                        >Blog Short Description is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <mat-label
                  >Blog Description
                  <span class="text-danger">*</span></mat-label
                >
                <ckeditor
                  [editor]="Editor"
                  formControlName="blogContent"
                  [ngClass]="{
                    'is-invalid':
                      add.blogContent.touched && add.blogContent.errors
                  }"
                  (ready)="onReady($event)"
                  (change)="onChange($event)"
                >
                </ckeditor>
                <mat-error
                  *ngIf="add.blogContent.touched && add.blogContent.errors"
                >
                  <span *ngIf="add.blogContent.errors.required"
                    >Blog Description is required</span
                  >
                </mat-error>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 col-12">
            <div class="p-relative">
              <p class="logo-span">
                Blog Image <span class="text-danger">*</span>
              </p>
              <div class="text-center">
                <div class="circle">
                  <img class="profile-pic" [src]="image_url" />
                </div>
                <div>
                  <label for="files" class="p-image">Upload Image</label>
                  <input
                    class="file-upload"
                    (change)="onSelectImage($event)"
                    id="files"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                </div>
              </div>
              <p>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg) <br />(max file size:
                  10mb)</span
                >
              </p>
              <p *ngIf="logoCheck == true" class="text-danger">
                Blog Image is required
              </p>
            </div>
            <div class="row">
              <div class="col-4" *ngFor="let list of mydata; let i = index">
                <div class="p-relative">
                  <img class="profile-pic-sml" [src]="list.url" />
                  <span class="hover-span-delete">
                    <i
                      class="fas fa-trash delete-i"
                      (click)="deleteImage(i, list.id)"
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="text-center mt-5">
        <button
          class="mr-2 new-btn-color2"
          mat-raised-button
          color="warn"
          (click)="cancelBlog()"
        >
          Cancel
        </button>
        <button
          mat-raised-button
          class="new-btn-color"
          color="primary"
          (click)="saveBlog()"
        >
          {{ savelbl }}
        </button>
      </div>
    </div>
  </div>
</section>
